import styled, {css} from "styled-components";
import {ErrorText, Text} from "./Shared";
import {solease_cultured, solease_gray_2, solease_red} from "../../constants/Colors";
import {useEffect, useRef, useState} from "react";
import useOutsideAlerter from "../../utils/hooks/useOutsideAlerter";

const Wrapper = styled('div')<{ error?: boolean, ref?: any }>`
  position: relative;
  margin-bottom: 25px;

  ${Text} {
    margin-bottom: 5px;
  }

  ${ErrorText} {
    opacity: ${props => props.error ? 1 : 0}
  }

  @media (min-width: 900px) {
    max-width: 60%;
  }
`

const DropdownControl = styled('div')<{ error?: boolean }>`
  width: 100%;
  min-height: 46px;
  background-color: ${solease_cultured};
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  transition: box-shadow ease-in .2s;
  font-size: 16px;
  cursor: pointer;
  appearance: none;
  display: flex;
  align-items: center;
  background-color: ${solease_cultured};
  padding: 10px 15px;
  padding-right: 38px;
  position: relative;

  border: 1px solid ${props => props.error ? solease_red : 'transparent'};
  border-radius: 4px;
`

const DropdownMenu = styled.div`
  border: none;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  background-color: ${solease_cultured};
  position: absolute;
  width: 100%;
  z-index: 10;

  div {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    min-height: 41px;
    background-color: white;
    border-top: 1px solid ${solease_gray_2};
    transition: all .2s;
    cursor: pointer;

    &:hover {
      background-color: ${solease_cultured};
    }
  }
`

const Arrow = styled('span')<{ open?: boolean }>`
  position: absolute;
  right: 10px;
  top: 8px;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-width: 4px;
  border-bottom: none;
  border-right: none;
  border-top: 4px solid;
  border-left: 4px solid;
  border-radius: 1px;
  border-color: ${solease_gray_2};
  transform: rotate(225deg);
  transition: all .2s;

  ${props => props.open && css`
    margin-top: 10px;
    transform: rotate(45deg);
  `}
`

interface OptionInterface {
    label: string,
    value: string | number
}

interface StyledDropdownInterface {
    label?: string
    error?: boolean
    value?: any
    options: OptionInterface[]

    onChange(option: any): void
}

const StyledDropdown = ({label, options, error, onChange}: StyledDropdownInterface) => {

    const [isOpen, setIsOpen] = useState(false)
    const [selectedOption, setSelectedOption] = useState<OptionInterface>({label: '', value: ''})

    const ref = useRef(undefined)
    useOutsideAlerter(ref, () => setIsOpen(false))

    const onOptionClicked = (option: OptionInterface) => {
        setSelectedOption(option)
        setIsOpen(false)
    }
    //eslint-disable-next-line
    useEffect(() => onChange(selectedOption), [selectedOption])

    return <Wrapper ref={ref} error={error}>
        <ErrorText>Dit veld is verplicht</ErrorText>
        <Text style={{marginRight: '90px'}} large>{label}</Text>
        <DropdownControl onClick={() => setIsOpen(!isOpen)}
                         error={error}>
            {selectedOption.label}
            <Arrow open={isOpen}/>
        </DropdownControl>
        {
            isOpen && <DropdownMenu>
                {
                    options.map((option, index) => <div key={index} onClick={() => onOptionClicked(option)}>
                        {option.label}
                    </div>)
                }
            </DropdownMenu>
        }
    </Wrapper>
}

export default StyledDropdown
